import { DefaultError, UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';
import { useDucatClient } from '@/context/DucatClientCtx';

import { QueryKeys } from '../query-keys';

import { quantaApi } from './quantaApi';
import { CompletedTask } from './useQuantaMissionTasks';
import { Referral } from './useQuantaRegister';

export interface Level {
  level_one: number;
  level_two: number;
  level_three: number;
}

export interface RegisterUser {
  user_id: string;
  test_net_wallet: string;
  test_net_pk: string;
}

export interface QuantaUser extends RegisterUser {
  discord_id: string | null;
  twitter_id: string | null;
  telegram_id: string | null;
  matrica_id: string | null;
  vault_id: string;
  level: number;
}

export interface QuantaLoginResponse {
  data: {
    user: QuantaUser;
    referral_id: string;
    referral: Referral;
    points_total: number;
    ranking: number | null;
    referred_users: number;
    referral_points: number;
    completed_tasks_count: number;
    completed_tasks: CompletedTask[];
    levels: Level;
  };
}

type QueryOptionsParam = Omit<UseQueryOptions<QuantaLoginResponse, DefaultError>, 'queryKey' | 'queryFn'>;

export const useQuantaLogin = (options?: QueryOptionsParam): UseQueryResult<QuantaLoginResponse, Error> => {
  const { quantaHeaders: headers, walletAddress } = useDucatClient();

  return useQuery({
    queryKey: [QueryKeys.quantaLogin, walletAddress],
    queryFn: async () => {
      const result = await quantaApi.get('/login', {
        headers,
      });

      return result.data;
    },
    staleTime: 0, // made on purpose
    retry: false,
    ...options,
    enabled: !!headers && !!walletAddress && (typeof options?.enabled === 'undefined' || !!options?.enabled),
  });
};
